<template>
  <section>
    <title>Dashboard | Server Security</title>
    <div class="page-loader" v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
    <div class="state-bar" v-if="loaded">
      <a href="/dashboard">Go To The Server Selection Menu</a>
    </div>
    <form class="form" v-if="loaded">
      <div class="form-field">
        <p class="form-field-title">Server Firewall</p>
        <p class="form-field-title-description">Prevents globally banned users from joining the server.</p>
        <v-select :options="options" @input="update('firewall-opt')" v-model="firewallOpt"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Smart Shield</p>
        <p class="form-field-title-description">Automatically triggers "Under Attack" mode upon mass-joins and kicks out the culprits.</p>
        <v-select :options="options" @input="update('shield-opt')" v-model="shieldOpt"></v-select>
      </div>
      <i><div class="form-field">
        <p class="form-field-title">Lockdown Mode (Disabled: Use the 'lockdown' command to toggle this.)</p>
        <p class="form-field-title-description">This setting cannot be toggled via the dashboard, while we are updating the dashboard. Please use the command to set this.</p>
        <v-select :options="[]" @input="update('lockdown-opt')" v-model="lockdownOpt" class="select-disabled"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Under Attack Mode (Disabled: Use the 'raid-mode' command to toggle this.)</p>
        <p class="form-field-title-description">This setting cannot be toggled via the dashboard, while we are updating the dashboard. Please use the command to set this.</p>
        <v-select :options="[]" @input="update('attack-opt')" v-model="attackOpt"></v-select>
      </div></i>
    </form>
  </section>
</template>

<script>
export default {
  name: "Security",
  watch: {
    confirm (value) {
      this.$emit("setPromptVisibility", value);
    },
    saving (value) {
      this.$emit("setPromptLoading", value);
    }
  },
  data () {
    return {
      loaded: false,
      settings: {},
      cache: {},
      changes: {},
      confirm: false,
      upgrade: 0,
      saving: false,
      options: [
        {
          label: "Enabled",
          value: "enabled"
        },
        {
          label: "Disabled",
          value: "disabled"
        }
      ],
      enabled: {
        label: "Enabled",
        value: "enabled"
      },
      disabled: {
        label: "Disabled",
        value: "disabled"
      },
      lockdownOpt: null,
      lockdown: null,
      attackOpt: null,
      attack: null,
      firewallOpt: null,
      firewall: null,
      shieldOpt: null,
      shield: null
    };
  },
  methods: {
    fetchGuildData: async function () {
      const response = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/cache`, {
        withCredentials: true,
        credentials: "same-origin"
      });
      this.cache = response.data.data;

      const settingsResponse = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/settings`, {
        withCredentials: true,
        credentials: "same-origin"
      });

      this.settings = settingsResponse.data.data;
      this.loaded = true;

      this.init();
    },
    init: function () {
      this.lockdownOpt = this.settings.lockdown ? this.enabled : this.disabled;
      this.lockdown = this.settings.lockdown ? "enabled" : "disabled";

      this.attackOpt = this.settings.raid_mode ? this.enabled : this.disabled;
      this.attack = this.settings.raid_mode ? "enabled" : "disabled";

      this.firewallOpt = this.settings.server_firewall ? this.enabled : this.disabled;
      this.firewall = this.settings.server_firewall ? "enabled" : "disabled";

      this.shieldOpt = this.settings.smart_shield ? this.enabled : this.disabled;
      this.shield = this.settings.smart_shield ? "enabled" : "disabled";
    },
    arraify: function (object) {
      let output = [];
      for (const key of Object.keys(object)) {
        output.push(object[key]);
      }
      return output;
    },
    save: async function () {
      this.saving = true;

      await this.$axios.post(`${this.$apiBase}/v1/settings/${this.settings.id}/lockdown`, {
        "lockdown-mode": this.lockdown,
        "raid-mode": this.attack,
        "server-firewall": this.firewall,
        "smart-shield": this.shield
      }, {
        withCredentials: true,
        credentials: "same-origin"
      });

      await this.fetchGuildData();
      this.changes = {};
      this.saving = false;
      this.updateBar();
    },
    update: async function (field) {
      switch(field) {
        case "lockdown-opt":
          this.lockdown = this.lockdownOpt ? this.lockdownOpt.value : "disabled";
          if (this.bool(this.lockdown) === this.settings.lockdown) this.changes[field] = false;
          else this.changes[field] = true;
          break;
        case "attack-opt":
          this.attack = this.attackOpt ? this.attackOpt.value : "disabled";
          if (this.bool(this.attack) === this.settings.raid_mode) this.changes[field] = false;
          else this.changes[field] = true;
          break;
        case "firewall-opt":
          this.firewall = this.firewallOpt ? this.firewallOpt.value : "disabled";
          if (this.bool(this.firewall) === this.settings.server_firewall) this.changes[field] = false;
          else this.changes[field] = true;
          break;
        case "shield-opt":
          this.shield = this.shieldOpt ? this.shieldOpt.value : "disabled";
          if (this.bool(this.shield) === this.settings.smart_shield) this.changes[field] = false;
          else this.changes[field] = true;
          break;
        default:
          console.error(`${field} is not a valid settings field.`);
      }
      this.updateBar();
    },
    bool: function (str) {
      if (str.toLowerCase() === "enabled") {
        return true;
      } else {
        return false;
      }
    },
    updateBar: function () {
      if (this.arraify(this.changes).some(c => c === true)) {
        this.confirm = true;
      } else {
        this.confirm = false;
      }
    },
    discard: function () {
      this.init();
      this.changes = {};
      this.updateBar();
    }
  },
  mounted() {
    this.fetchGuildData();
  }
}
</script>